import { jsxs as H, jsx as C } from "react/jsx-runtime";
function h({
  width: i = 76,
  height: t = 14,
  darkMode: l = !1
}) {
  return /* @__PURE__ */ H(
    "svg",
    {
      width: i,
      height: t,
      viewBox: "0 0 76 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C(
          "rect",
          {
            x: "0.277344",
            width: "13.8628",
            height: "13.8629",
            rx: "4.20086",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ H("g", { "clip-path": "url(#clip0_1829_36474)", children: [
          /* @__PURE__ */ C(
            "path",
            {
              d: "M8.67857 4.98024H7.83945C7.54294 4.98024 7.2998 4.74007 7.2998 4.44059V3.60444C7.2998 3.30496 7.53998 3.06479 7.83945 3.06479H8.67857C8.97508 3.06479 9.21822 3.30496 9.21822 3.60444V4.44356C9.21525 4.74007 8.97508 4.98024 8.67857 4.98024Z",
              fill: l ? "#111111" : "#fff"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M6.76353 6.89559H5.92441C5.6279 6.89559 5.38477 6.65542 5.38477 6.35594V5.51682C5.38477 5.22031 5.62494 4.97717 5.92441 4.97717H6.76353C7.06004 4.97717 7.30318 5.21735 7.30318 5.51682V6.35594C7.30022 6.65542 7.06004 6.89559 6.76353 6.89559Z",
              fill: l ? "#111111" : "#fff"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M8.67857 8.81112H7.83945C7.54294 8.81112 7.2998 8.57094 7.2998 8.27147V7.43235C7.2998 7.13584 7.53998 6.8927 7.83945 6.8927H8.67857C8.97508 6.8927 9.21822 7.13287 9.21822 7.43235V8.27147C9.21525 8.57094 8.97508 8.81112 8.67857 8.81112Z",
              fill: l ? "#111111" : "#fff"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M6.76353 10.7266H5.92441C5.6279 10.7266 5.38477 10.4864 5.38477 10.187V9.3508C5.38477 9.05429 5.62494 8.81116 5.92441 8.81116H6.76353C7.06004 8.81116 7.30318 9.05133 7.30318 9.3508V10.1899C7.30022 10.4864 7.06004 10.7266 6.76353 10.7266Z",
              fill: l ? "#111111" : "#fff"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M7.29896 9.27077C7.29896 9.27077 7.2782 8.81118 7.85343 8.81118C8.42866 8.81118 7.29896 8.29526 7.29896 8.29526C7.29896 8.29526 7.25745 8.81118 6.76524 8.81118C6.27304 8.81118 7.02914 9.43385 7.29896 9.27077Z",
              fill: l ? "#111111" : "#fff"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M7.29896 5.43984C7.29896 5.43984 7.2782 4.98025 7.85343 4.98025C8.42866 4.98025 7.29896 4.46432 7.29896 4.46432C7.29896 4.46432 7.25745 4.98025 6.76524 4.98025C6.27304 4.98025 7.02914 5.59996 7.29896 5.43984Z",
              fill: l ? "#111111" : "#fff"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M7.31692 7.64897C7.31692 7.64897 7.30802 6.89583 6.72983 6.89583C6.15164 6.89583 7.2843 6.38287 7.2843 6.38287C7.2843 6.38287 7.32581 6.8988 7.81802 6.8988C8.31022 6.8988 7.58674 7.81205 7.31692 7.64897Z",
              fill: l ? "#111111" : "#fff"
            }
          )
        ] }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M17.1644 9.96814C16.8032 9.77401 16.4975 9.49669 16.2753 9.13616C16.053 8.77564 15.9418 8.35965 15.9141 7.8882H17.1922C17.22 8.16552 17.2755 8.38738 17.3867 8.58151C17.4978 8.77564 17.6367 8.94203 17.8312 9.02523C18.0257 9.13616 18.248 9.19163 18.4703 9.19163H19.026C19.2205 9.19163 19.3872 9.13616 19.5817 9.05296C19.7762 8.96977 19.9151 8.8311 20.0262 8.66471C20.1374 8.49831 20.193 8.27645 20.193 8.05459C20.193 7.805 20.1096 7.61087 19.9707 7.44448C19.8318 7.27808 19.6373 7.16715 19.415 7.08395C19.1927 7.00075 18.8871 6.88982 18.4981 6.77889C17.9702 6.64023 17.5534 6.50157 17.22 6.36291C16.8865 6.22424 16.6087 6.00238 16.3864 5.69732C16.1641 5.39227 16.0252 5.00401 16.0252 4.50482C16.0252 4.08883 16.1363 3.70058 16.3308 3.39552C16.5531 3.06273 16.831 2.81314 17.1644 2.64674C17.5256 2.48035 17.8868 2.36942 18.3036 2.36942H18.8593C19.2761 2.36942 19.665 2.45261 20.0262 2.61901C20.3597 2.7854 20.6375 3.035 20.8598 3.36779C21.0821 3.70058 21.221 4.08883 21.2488 4.56029H19.9707C19.9151 4.19977 19.804 3.92244 19.6095 3.72831C19.415 3.53418 19.1649 3.45099 18.8315 3.45099H18.3036C18.1369 3.45099 17.9702 3.47872 17.8034 3.56192C17.6367 3.64511 17.5256 3.75604 17.4145 3.89471C17.3311 4.03337 17.2755 4.19977 17.2755 4.42163C17.2755 4.67122 17.3589 4.86535 17.4978 5.00401C17.6367 5.14267 17.8312 5.28134 18.0257 5.36453C18.248 5.44773 18.5259 5.53093 18.9426 5.64186C19.4705 5.78052 19.8873 5.91918 20.2207 6.05785C20.5542 6.19651 20.832 6.41837 21.0821 6.75116C21.3321 7.05622 21.4433 7.47221 21.4433 8.02686C21.4433 8.49831 21.3321 8.88657 21.1099 9.21936C20.8876 9.55215 20.5819 9.82948 20.2207 10.0236C19.8318 10.2177 19.415 10.3009 18.9704 10.3009H18.4147C17.9424 10.2732 17.5256 10.1623 17.1644 9.96814Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.8604 4.58795H23.0273V10.1899H21.8604V4.58795Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23.7763 4.58798H24.9432V5.41996C25.0822 5.17036 25.2489 4.9485 25.5267 4.75438C25.7768 4.56025 26.0546 4.47705 26.3047 4.47705H26.7215C27.0827 4.47705 27.3883 4.56025 27.6106 4.72664C27.8329 4.89304 28.0274 5.1149 28.1941 5.44769C28.333 5.17036 28.5553 4.9485 28.8331 4.75438C29.111 4.56025 29.3888 4.47705 29.6945 4.47705H30.1113C30.4447 4.47705 30.7503 4.56025 31.0004 4.75438C31.2504 4.9485 31.4727 5.17036 31.6117 5.50316C31.7506 5.80821 31.8339 6.16874 31.8339 6.55699V10.1622H30.667V6.77885C30.667 6.52926 30.6392 6.33513 30.5558 6.141C30.4725 5.94688 30.3891 5.80821 30.2502 5.69728C30.1113 5.58635 29.9723 5.53089 29.8056 5.53089H29.4444C29.2499 5.53089 29.0554 5.61409 28.8887 5.75275C28.722 5.89141 28.6109 6.11327 28.4997 6.36287C28.4164 6.61246 28.3608 6.88978 28.3608 7.16711V10.1622H27.1938V6.77885C27.1938 6.52926 27.166 6.33513 27.0827 6.141C26.9993 5.94688 26.916 5.80821 26.7771 5.69728C26.6381 5.58635 26.4992 5.53089 26.3325 5.53089H25.9713C25.7768 5.53089 25.5823 5.61409 25.4156 5.75275C25.2489 5.89141 25.1377 6.11327 25.0266 6.36287C24.9432 6.61246 24.8877 6.88978 24.8877 7.16711V10.1622H23.7207V4.58798H23.7763Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M36.6141 4.89308C36.9753 5.14267 37.2532 5.50319 37.4477 5.94692C37.6422 6.39064 37.7533 6.86209 37.7533 7.38901C37.7533 7.91593 37.6422 8.41511 37.4477 8.85884C37.2532 9.30256 36.9753 9.63535 36.6141 9.91267C36.2529 10.1623 35.8362 10.3009 35.3638 10.3009H35.0304C34.7803 10.3009 34.5303 10.2177 34.2802 10.0791C34.0301 9.94041 33.8078 9.74628 33.6689 9.52442V11.4934H32.502V4.58802H33.6689V5.28133C33.8078 5.05947 34.0301 4.86535 34.2802 4.72668C34.5303 4.58802 34.8081 4.50482 35.0582 4.50482H35.3916C35.8639 4.50482 36.2529 4.61575 36.6141 4.89308ZM34.2246 5.75279C34.0301 5.91918 33.8634 6.14104 33.7523 6.41837C33.6411 6.69569 33.5856 7.02849 33.5856 7.38901C33.5856 7.74953 33.6411 8.08232 33.7523 8.35965C33.8634 8.63697 34.0301 8.85884 34.2246 9.02523C34.4191 9.19163 34.6414 9.27482 34.8915 9.27482H35.2805C35.5027 9.27482 35.725 9.19163 35.9195 9.02523C36.114 8.85884 36.2807 8.63697 36.3919 8.35965C36.503 8.08232 36.5864 7.74953 36.5864 7.38901C36.5864 7.02849 36.5308 6.72343 36.3919 6.41837C36.2807 6.14104 36.114 5.91918 35.9195 5.75279C35.725 5.58639 35.5027 5.50319 35.2805 5.50319H34.8915C34.6414 5.50319 34.4191 5.58639 34.2246 5.75279Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M38.168 3.39545H39.3349V10.1622H38.168V3.39545Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.3908 9.82949C41.4186 9.88495 41.4186 9.96815 41.4186 10.0514C41.4186 10.1345 41.4464 10.19 41.4464 10.2732C41.4464 10.4396 41.4186 10.606 41.363 10.8001L41.0852 11.4657H42.2244C42.2799 11.3548 42.3355 11.2439 42.3633 11.1052L44.725 4.58804H43.5302L42.3911 7.86048C42.3077 8.11007 42.2243 8.41513 42.141 8.72019H42.0854C42.0021 8.41513 41.9187 8.11007 41.8354 7.83275L40.6684 4.5603H39.4736L41.2519 9.44123C41.3074 9.60763 41.363 9.71856 41.3908 9.82949Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M45.5918 2.36942H48.7037C49.2038 2.36942 49.6762 2.45261 50.0374 2.61901C50.4264 2.7854 50.7042 3.035 50.9265 3.36779C51.121 3.70058 51.2322 4.08883 51.2322 4.53256C51.2322 4.86535 51.1488 5.1704 51.0099 5.44773C50.871 5.72506 50.6487 5.97465 50.3986 6.16878C50.1485 6.36291 49.8707 6.50157 49.5651 6.58477L51.6489 10.1068H50.1208L48.7315 7.52767C48.5926 7.27808 48.4537 7.13942 48.3425 7.02849C48.2036 6.94529 48.0369 6.88982 47.8424 6.88982H46.8699V10.1068H45.6196V2.36942H45.5918ZM49.5928 5.5032C49.8429 5.28133 49.954 4.97628 49.954 4.61575C49.954 4.28296 49.8429 4.00564 49.5928 3.78378C49.3428 3.56192 49.0371 3.47872 48.6204 3.47872H46.8699V5.86372H48.5926C49.0094 5.83599 49.3428 5.72506 49.5928 5.5032Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M52.5934 8.30426C52.7046 8.60932 52.8713 8.83118 53.038 8.99757C53.2325 9.16397 53.427 9.24717 53.6771 9.24717H54.0938C54.3717 9.24717 54.594 9.16397 54.8162 8.96984C55.0107 8.77571 55.1497 8.55385 55.2052 8.30426H56.3166C56.2889 8.66478 56.1499 8.99757 55.9554 9.2749C55.7609 9.57996 55.4831 9.80182 55.1497 9.96821C54.844 10.1346 54.4828 10.2178 54.0938 10.2178H53.6771C53.2325 10.2178 52.8157 10.1069 52.4545 9.85728C52.0933 9.60769 51.7877 9.2749 51.5654 8.83118C51.3431 8.38746 51.2598 7.88827 51.2598 7.33362C51.2598 6.77897 51.3709 6.27978 51.5932 5.83606C51.8155 5.39234 52.1211 5.05955 52.4823 4.80996C52.8435 4.56036 53.2325 4.44943 53.6493 4.44943H54.0938C54.5106 4.44943 54.8996 4.56036 55.2608 4.80996C55.5942 5.05955 55.8721 5.36461 56.0666 5.7806C56.2611 6.19658 56.3722 6.6403 56.3722 7.11176C56.3722 7.22269 56.3722 7.30589 56.3722 7.36135C56.3722 7.44455 56.3722 7.50002 56.3444 7.55548H51.9266V6.66804H55.2052C55.1775 6.44618 55.1219 6.22432 55.0385 6.03019C54.9552 5.83606 54.8162 5.66967 54.6495 5.55874C54.4828 5.4478 54.3161 5.39234 54.1216 5.39234H53.7326C53.5104 5.39234 53.3159 5.47554 53.1214 5.6142C52.9269 5.75286 52.7602 5.97472 52.649 6.27978C52.5379 6.58484 52.4823 6.91763 52.4823 7.27815C52.4267 7.66641 52.4823 8.02693 52.5934 8.30426Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M56.0117 4.53256H57.2343L58.3734 7.86047C58.4568 8.11006 58.5402 8.41512 58.6235 8.74791H58.6513C58.7347 8.44285 58.818 8.1378 58.9014 7.8882L60.0405 4.56029H61.2631L59.2626 10.1623H58.04L56.0117 4.53256Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M61.4297 4.53256H62.5967V10.1345H61.4297V4.53256Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M64.3474 8.30423C64.4585 8.60929 64.6252 8.83115 64.7919 8.99754C64.9864 9.16394 65.1809 9.24714 65.431 9.24714H65.8477C66.1256 9.24714 66.3479 9.16394 66.5702 8.96981C66.7647 8.77568 66.9036 8.55382 66.9591 8.30423H68.0705C68.0428 8.66475 67.9038 8.99754 67.7093 9.27487C67.5148 9.57993 67.237 9.80179 66.9036 9.96818C66.5702 10.1346 66.2367 10.2178 65.8477 10.2178H65.431C64.9864 10.2178 64.5696 10.1068 64.2084 9.85725C63.8472 9.60766 63.5416 9.27487 63.3193 8.83115C63.097 8.38743 63.0137 7.88824 63.0137 7.33359C63.0137 6.77894 63.1248 6.27975 63.3471 5.83603C63.5694 5.39231 63.875 5.05952 64.2362 4.80993C64.5974 4.56033 64.9864 4.4494 65.4032 4.4494H65.8477C66.2645 4.4494 66.6535 4.56033 67.0147 4.80993C67.3481 5.05952 67.626 5.36458 67.8205 5.78056C68.015 6.19655 68.1261 6.64027 68.1261 7.11173C68.1261 7.22266 68.1261 7.30586 68.1261 7.36132C68.1261 7.44452 68.1261 7.49998 68.0983 7.55545H63.6805V6.66801H66.9314C66.9036 6.44615 66.848 6.22429 66.7646 6.03016C66.6813 5.83603 66.5424 5.66963 66.3757 5.5587C66.2089 5.44777 66.0422 5.39231 65.8477 5.39231H65.4588C65.2365 5.39231 65.042 5.47551 64.8475 5.61417C64.653 5.75283 64.4863 5.97469 64.3751 6.27975C64.264 6.58481 64.2084 6.9176 64.2084 7.27812C64.1529 7.66638 64.2362 8.0269 64.3474 8.30423Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M67.875 4.53258H69.0698L69.9311 7.63863C69.9867 7.91596 70.07 8.19328 70.1256 8.52607H70.1534C70.2089 8.22102 70.2923 7.91596 70.3757 7.63863L71.2926 4.50485H72.404L73.3209 7.63863C73.3764 7.88823 73.4598 8.19328 73.5154 8.52607H73.5431C73.5987 8.22102 73.6821 7.91596 73.7376 7.63863L74.5712 4.50485H75.7659L74.1544 10.1068H72.9874L72.0428 6.97305C71.9594 6.69572 71.9038 6.4184 71.8205 6.08561H71.7649C71.7093 6.4184 71.626 6.69572 71.5426 6.97305L70.5979 10.1068H69.431L67.875 4.53258Z",
            fill: l ? "white" : "black"
          }
        ),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_1829_36474", children: /* @__PURE__ */ C(
          "rect",
          {
            width: "3.8309",
            height: "7.66181",
            fill: l ? "white" : "black",
            transform: "translate(5.38477 3.06476)"
          }
        ) }) })
      ]
    }
  );
}
export {
  h as default
};
